import image1 from "../../../assets/Images/1.jpg";

// Guides profile pic
import fatima from "../../../assets/Images/Guides/Fatima.jpg";
import haval from "../../../assets/Images/Guides/Haval.png";
import harbi from "../../../assets/Images/Guides/Harbi.png";
import nuha from "../../../assets/Images/Guides/Nuha.webp";
import yousif from "../../../assets/Images/Guides/Yousif.png";
import aliH from "../../../assets/Images/Guides/AliHameed.png";
import lubna from "../../../assets/Images/Guides/Lubna.png";
import hussein from "../../../assets/Images/Guides/Hussein Rashid.png";

// Guides Cover
import sky from "../../../assets/Images/Guides/CoverPhoto/Sky.jpeg";
import camping from "../../../assets/Images/Guides/CoverPhoto/camping.jpeg";
import basrah from "../../../assets/Images/Guides/CoverPhoto/Basrah.jpeg";
import baghdad from "../../../assets/Images/Guides/CoverPhoto/Baghdad.jpeg";
import karbala from "../../../assets/Images/Guides/CoverPhoto/Karbala.jpeg";
import najaf from "../../../assets/Images/Guides/CoverPhoto/Najaf.jpeg";
import kurdistan from "../../../assets/Images/Guides/CoverPhoto/Kurdistan.jpeg";
import anbar from "../../../assets/Images/Guides/CoverPhoto/Anbar.jpeg";

const GuideData = [
	// 1 Fatima
	{
		idGuide: 1,
		image: fatima,
		imgCover: sky,
		name: "Fatima Ahmed",
		province: " Baghdad ",
		perHour: "20",
		rate: 4,
		noOfReviews: 15,
		Quote:
			"Passionate about helping others achieve their goals",
		ProgramsData: [
			{
				id: 101,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 102,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 103,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 104,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 1001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Fatima provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 1002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Fatimaguidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Fatimaexpertise and highly recommend as a guide.",
			},
			{
				userId: 1003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Fatima was our guide during our trip to Iraq. While the journey was interesting, Fatima communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
			{
				userId: 1004,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Fatima was our guide during our trip to Iraq. While the journey was interesting, Fatima communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Fatima, your guide to the vibrant streets of Baghdad. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Historical Tours",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
				],
			},
		],
	},
	// 2 Haval
	{
		idGuide: 2,
		image: haval,
		imgCover: camping,
		name: "Haval",
		province: " Erbil ",
		perHour: 60,
		rate: 5,
		noOfReviews: 10,
		Quote:
			"Iraq: where history comes to life in every step you take",
		ProgramsData: [
			{
				id: 201,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 202,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 203,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 204,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 2001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Haval provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 2002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Haval guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Haval expertise and highly recommend as a guide.",
			},
			{
				userId: 2003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Haval was our guide during our trip to Iraq. While the journey was interesting,Haval communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Haval, your guide to the vibrant streets of Erbil. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,Kurdish", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 3 Harbi
	{
		idGuide: 3,
		image: harbi,
		imgCover: basrah,
		name: "Harbi Adel",
		province: " Basrah ",
		perHour: 30,
		rate: 5,
		noOfReviews: 5,
		Quote:
			"Explore the cradle of civilization, embrace the spirit of Iraq",
		ProgramsData: [
			{
				id: 301,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 302,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 303,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 304,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 3001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Harbi provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 3002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Harbi guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Harbi expertise and highly recommend as a guide.",
			},
			{
				userId: 3003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Harbi was our guide during our trip to Iraq. While the journey was interesting,Harbi communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Harbi, your guide to the vibrant streets of Basrah. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 4 Nuha
	{
		idGuide: 4,
		image: nuha,
		imgCover: baghdad,
		name: "Nuha M",
		province: " Baghdad ",
		perHour: 50,
		rate: 5,
		noOfReviews: 4,
		Quote:
			"Journey through the land of a thousand tales, travel to Iraq",
		ProgramsData: [
			{
				id: 401,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 402,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 403,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 404,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 4001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Nuha provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 4002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Nuha guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Nuha expertise and highly recommend as a guide.",
			},
			{
				userId: 4003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Nuha was our guide during our trip to Iraq. While the journey was interesting,Nuhacommunication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Nuha, your guide to the vibrant streets of Baghdad. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 5 Yousif
	{
		idGuide: 5,
		image: yousif,
		imgCover: karbala,
		name: "Yousif Al-Fahad",
		province: " Karbala ",
		perHour: 80,
		rate: 5,
		noOfReviews: 10,
		Quote:
			"Feel the spirit of Karbala's rituals, a journey of deep significance",
		ProgramsData: [
			{
				id: 501,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 502,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 503,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 504,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 5001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Yousif provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 5002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Yousif guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Yousif expertise and highly recommend as a guide.",
			},
			{
				userId: 5003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Yousif was our guide during our trip to Iraq. While the journey was interesting,Yousif communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Yousif, your guide to the vibrant streets of Karbala. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,Kurdish", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 6 Ali
	{
		idGuide: 6,
		image: aliH,
		imgCover: najaf,
		name: "Ali Hameed",
		province: " Baghdad ",
		perHour: "20",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"Travel to Iraq, where the past meets the present in harmony",
		ProgramsData: [
			{
				id: 601,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1717966800",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 602,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 603,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 604,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 6001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Ali provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 6002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Ali guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Ali expertise and highly recommend as a guide.",
			},
			{
				userId: 6003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Ali was our guide during our trip to Iraq. While the journey was interesting,Ali communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Ali, your guide to the vibrant streets of Baghdad. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,Kurdish", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 7 Lubna
	{
		idGuide: 7,
		image: lubna,
		imgCover: kurdistan,
		name: "Lubna Sadiq",
		province: "Sulaymaniyah",
		perHour: "40",
		rate: 3.5,
		noOfReviews: 13,
		Quote:
			"Experience the warmth of Iraqi hospitality, a journey like no other",
		ProgramsData: [
			{
				id: 701,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 702,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 703,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 704,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 7001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"Lubna provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 7002,
				userName: "Emma Davis",
				userGuideRate: 5,
				comment:
					"Lubna guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Lubna expertise and highly recommend as a guide.",
			},
			{
				userId: 7003,
				userName: "Michael Smith",
				userGuideRate: 3,
				comment:
					"Lubna was our guide during our trip to Iraq. While the journey was interesting, Lubna communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Lubna, your guide to the vibrant streets of Sulaymaniyah. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic", " ,Kurdish", " ,English"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
	// 8 Hussein
	{
		idGuide: 8,
		image: hussein,
		imgCover: anbar,
		name: "Hussein Rashid",
		province: " Anbar ",
		perHour: "15",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"Iraq, a mosaic of cultures waiting to be explored",
		ProgramsData: [
			{
				id: 801,
				image: image1,
				name: "Sands of Mesopotamia",
				describe:
					"Explore the ancient desert landscapes and archaeological wonders of Mesopotamia",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"The second day promises an immersive cultural experience as you continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences, gaining insights into the traditions of the region.",
							"This day is an opportunity to connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"On the final day of your adventure, explore any remaining archaeological sites, ensuring you've captured the essence of the desert landscapes.",
							"Take the time to appreciate the beauty that Mesopotamia offers.",
							"The trip concludes with a farewell event, providing a fitting conclusion to your exploration.",
							"Afterward, depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
				},
			},
			{
				id: 802,
				image: image1,
				name: "Kurdish Discovery Quest",
				describe:
					"Immerse yourself in the rich culture and stunning landscapes of the Kurdish region",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "Arrival and Introduction",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin the exploration ofBegin your exploration of the Kurdish region.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Cultural Immersion",
						activities: [
							"Continue the journey through historical wonders.",
							"Engage in cultural activities and experiences.",
							"Connect with local communities and learn about their traditions.",
						],
					},
					day3: {
						title: "Nature and Adventure",
						activities: [
							"Explore the natural beauty of the Kurdish landscapes.",
							"Participate in outdoor activities and adventures.",
							"Enjoy the unique ecosystem and vibrant local culture.",
						],
					},
					day4: {
						title: "Farewell and Departure",
						activities: [
							"Wrap up your adventure with a farewell event.",
							"Depart for your onward journey with cherished memories of the Kurdish Discovery Quest.",
						],
					},
				},
			},
			{
				id: 803,
				image: image1,
				name: "Baghdad Heritage",
				describe:
					"Uncover the historical treasures and vibrant culture of Iraq's capital city",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "Arrival and Exploration",
						activities: [
							"Arrive at the designated starting point.",
							"Get acquainted with fellow travelers and your guide.",
							"Begin your exploration of ancient desert landscapes.",
							"Visit key archaeological sites.",
							"Enjoy a welcome dinner.",
						],
					},
					day2: {
						title: "Immersive Cultural Experience",
						activities: [
							"Continue your journey through Mesopotamia's historical wonders.",
							"Engage in various cultural activities and experiences.",
							"Connect with local communities, fostering a deeper understanding of the rich history that surrounds you.",
						],
					},
					day3: {
						title: "Final Discoveries and Departure",
						activities: [
							"Explore any remaining archaeological sites, capturing the essence of the desert landscapes.",
							"Take time to appreciate the beauty that Mesopotamia offers.",
							"Conclude the trip with a farewell event, providing a fitting end to your exploration.",
							"Depart for your onward journey, carrying the memories of Mesopotamia with you.",
						],
					},
					day4: {
						title: "Departure",
						activities: [
							"Check-out from your accommodation.",
							"Reflect on the experiences and memories created during the.",
							"Depart for your onward journey.",
						],
					},
				},
			},
			{
				id: 804,
				image: image1,
				name: "Marshes Serenity Retreat",
				describe:
					"mmerse yourself in the tranquil beauty of Iraq's marshes, experiencing the unique ecosystem and vibrant local culture",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "Arrival and Nature Immersion",
						activities: [
							"Arrive at the serene retreat location surrounded by marshes.",
							"Check-in to your comfortable accommodation.",
							"Immerse yourself in nature with a guided walk through the marshes.",
							"Participate in a mindfulness session to relax and unwind.",
							"Enjoy a delicious dinner prepared with local flavors.",
						],
					},
					day2: {
						title: "Wellness and Departure",
						activities: [
							"Start the day with a rejuvenating yoga session by the marshes.",
							"Indulge in a nourishing breakfast to kick-start your day.",
							"Experience a spa session or massage for ultimate relaxation.",
							"Take part in a nature photography workshop or bird watching activity.",
							"Conclude your retreat with a healthy lunch.",
							"Check-out and depart with a sense of tranquility and refreshed spirit.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 8001,
				userName: "Smith Johnson",
				userGuideRate: 3.5,
				comment:
					"Hussein provided a unique and insightful journey through Iraq. This guide was knowledgeable, friendly, and made the experience truly special. I highly recommend their services.",
			},
			{
				userId: 8002,
				userName: "Emma Watsin",
				userGuideRate: 5,
				comment:
					"Hussein guidance made my visit to Iraq exceptional. The deep knowledge of the culture and history, combined with a warm and welcoming attitude, created an unforgettable experience. I'm grateful for Hussein expertise and highly recommend as a guide.",
			},
			{
				userId: 8003,
				userName: "Murphy Chris",
				userGuideRate: 2,
				comment:
					"Hussein was our guide during our trip to Iraq. While the journey was interesting, Hussein communication and organizational skills could be improved. Despite some hiccups, we appreciated that efforts and insights into local life.",
			},
		],
		GuideInfo: [
			{
				title: "I will Show you",
				description:
					"You will explore hidden gems, iconic landmarks, savor traditional Iraqi cuisine, and immerse in cultural festivals with me",
			},
			{
				title: "About me",
				description: `Hello, I'm Hussein, your guide to the vibrant streets of Anabr. Get ready for an unforgettable journey filled with rich history and cultural delights`,
			},
			{
				title: "Languages",
				description: ["Arabic"],
			},
			{
				title: "Activities",
				description: [
					"Hicking",
					", Culinary Adventures",
					", Market Explorations",
					", Local Festivals",
					", Camping",
				],
			},
		],
	},
];

export default GuideData;
